export { SNSPage as default } from '@/components/pages/Legal/SNSPolicy'
